<form [formGroup]="form" (ngSubmit)="submit()">
  <mat-card class="mat-elevation-z">
    <mat-form-field>
      <mat-label>Mot de passe actuel</mat-label>
      <input mat-input [type]="getFormType('currentPassword')" matInput formControlName="currentPassword"
        placeholder="Saisir le mot de passe actuel" autocomplete="off">
      <mat-icon matSuffix class="icon-click" (click)="toggleVisibility('currentPassword')">
        {{isVisible('currentPassword') ? 'visibility_off' : 'visibility'}}
      </mat-icon>
      <mat-error *ngIf="form.hasError('required',['currentPassword'])">Le mot de passe est requis</mat-error>
    </mat-form-field>

    <mat-form-field>
      <mat-label>Nouveau mot de passe</mat-label>
      <input matInput [type]="getFormType('newPassword')" formControlName="newPassword" placeholder="Saisir un nouveau mot de passe"
        (keyup)="isValidPassword($event)">
      <mat-icon matSuffix class="icon-click" (click)="toggleVisibility('newPassword')">
        {{isVisible('newPassword') ? 'visibility_off' : 'visibility'}}
      </mat-icon>
      <mat-error *ngIf="form.hasError('required',['newPassword'])">Le mot de passe est requis</mat-error>
    </mat-form-field>

    <mat-form-field>
      <mat-label>Confirmation du nouveau mot de passe</mat-label>
      <input matInput [type]="getFormType('confirmPassword')" formControlName="confirmPassword"
        placeholder="Re-saisir le nouveau mot de passe">
      <mat-icon matSuffix class="icon-click" (click)="toggleVisibility('confirmPassword')">
        {{isVisible('confirmPassword') ? 'visibility_off' : 'visibility'}}
      </mat-icon>
      <mat-error *ngIf="form.hasError('required',['confirmPassword'])">Le mot de passe est requis</mat-error>
    </mat-form-field>

    <p>Le nouveau mot de passe doit respecter les critères suivants :</p>
    <span>
      <mat-icon *ngIf="isSize" color="primary" inline="true">done</mat-icon>
      <mat-icon *ngIf="!isSize" color="red" inline="true">clear</mat-icon>
      8 caractères minimum
    </span>
    <span>
      <mat-icon *ngIf="isMaj" color="primary" inline="true">done</mat-icon>
      <mat-icon *ngIf="!isMaj" color="red" inline="true">clear</mat-icon>
      Au moins 1 lettre majuscule A-Z
    </span>
    <span>
      <mat-icon *ngIf="isMin" color="primary" inline="true">done</mat-icon>
      <mat-icon *ngIf="!isMin" color="red" inline="true">clear</mat-icon>
      Au moins 1 lettre minuscule a-z
    </span>
    <span>
      <mat-icon *ngIf="isNum" color="primary" inline="true">done</mat-icon>
      <mat-icon *ngIf="!isNum" color="red" inline="true">clear</mat-icon>
      Au moins 1 chiffre de 0 à 9
    </span>
    <span>
      <mat-icon *ngIf="isSpecial" color="primary" inline="true">done</mat-icon>
      <mat-icon *ngIf="!isSpecial" color="red" inline="true">clear</mat-icon>
      Au moins 1 caractère spécial (!, $, #, %, &#64;, etc.)
    </span>
    <span>
      <mat-icon *ngIf="isNotLogin" color="primary" inline="true">done</mat-icon>
      <mat-icon *ngIf="!isNotLogin" color="red" inline="true">clear</mat-icon>
      Différent de l'identifiant
    </span>

    <mat-card-actions>
      <button type="submit" mat-raised-button color="primary">Enregistrer</button>
    </mat-card-actions>
  </mat-card>
</form>